export default "__VITE_ASSET__DAnuzcoP__"